(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial_blog_carousel"] && !Shopify.designMode) return;
  try {
    
(function () {

  class EditorialBlog {
    constructor(section) {
      this.section        = section;
      this.id             = section.dataset.sectionId;
      this.tabBtns        = section.querySelectorAll('.editorial-blog__tab-btn');
      this.panels         = section.querySelectorAll('.editorial-blog__panel');
      this.carousels      = {};
      this.autoplayTimers = {};

      this._initTabs();
      this._initCarousels();
      this._initScrollArrow();
    }

    /* ── SCROLL ARROW ── */
   _initScrollArrow() {
  var tablist = this.section.querySelector('#eb-tablist');
  var arrow   = this.section.querySelector('#eb-scroll-arrow');
  if (!tablist || !arrow) return;

  var check = function () {
    var atEnd = tablist.scrollLeft + tablist.clientWidth >= tablist.scrollWidth - 8;
    arrow.classList.toggle('eb-arrow-hidden', atEnd);
  };

  tablist.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check, { passive: true });
  window.addEventListener('load', check);
  check();

  // Make arrow clickable — scroll tablist by one tab width
  arrow.addEventListener('click', function () {
    tablist.scrollBy({ left: 120, behavior: 'smooth' });
  });
  arrow.addEventListener('touchend', function (e) {
    e.preventDefault();
    tablist.scrollBy({ left: 120, behavior: 'smooth' });
  });
}

    /* ── TABS ── */
    _initTabs() {
      this.tabBtns.forEach((btn) => {
        btn.addEventListener('click', () => this._switchTab(btn));
        btn.addEventListener('keydown', (e) => {
          const tabs = [...this.tabBtns];
          const idx  = tabs.indexOf(btn);
          let next   = -1;
          if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
          if (e.key === 'ArrowLeft')  next = (idx - 1 + tabs.length) % tabs.length;
          if (next >= 0) { e.preventDefault(); tabs[next].click(); tabs[next].focus(); }
        });
      });
    }

    _switchTab(activeBtn) {
      const targetIndex = activeBtn.dataset.tabIndex;

      this.tabBtns.forEach((btn) => {
        const isActive = btn === activeBtn;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panelIndex === targetIndex;
        panel.classList.toggle('is-active', isActive);
        if (isActive) panel.removeAttribute('hidden');
        else          panel.setAttribute('hidden', '');
      });

      var tablist = this.section.querySelector('#eb-tablist');
      if (tablist) {
        var tabLeft  = activeBtn.offsetLeft;
        var tabWidth = activeBtn.offsetWidth;
        var listW    = tablist.clientWidth;
        tablist.scrollTo({ left: tabLeft - (listW / 2) + (tabWidth / 2), behavior: 'smooth' });
      }

      this._restartAutoplay(targetIndex);

      // Trigger slide content animation and restart dot fill for the new tab
      const activePanel = this.section.querySelector(
        '.editorial-blog__panel[data-panel-index="' + targetIndex + '"]'
      );
      if (activePanel) {
        const firstSlide = activePanel.querySelector('.editorial-blog__slide');
        if (firstSlide) this._animateSlideContent(firstSlide);

        const c = this.carousels[targetIndex];
        const currentDotIdx = c ? c.state.current : 0;
        const activeDot = activePanel.querySelector('[data-dot="' + currentDotIdx + '"]');
        if (activeDot) {
          activeDot.classList.remove('is-active');
          requestAnimationFrame(() => requestAnimationFrame(() => activeDot.classList.add('is-active')));
        }
      }
    }

    /* ── SLIDE CONTENT ANIMATION ── */
    _animateSlideContent(slide) {
      if (!slide) return;
      // Remove class from all slides first to reset
      const allSlides = this.section.querySelectorAll('.editorial-blog__slide');
      allSlides.forEach((s) => s.classList.remove('is-content-visible'));
      // Force reflow so CSS animation retriggers
      void slide.offsetHeight;
      slide.classList.add('is-content-visible');
    }

    /* ── CAROUSELS ── */
    _initCarousels() {
      this.panels.forEach((panel) => {
        const carousel = panel.querySelector('[data-carousel]');
        if (!carousel) return;

        const panelIndex  = panel.dataset.panelIndex;
        const track       = carousel.querySelector('[data-track]');
        const wrapper     = carousel.querySelector('[data-track-wrapper]');
        const dots        = carousel.querySelectorAll('[data-dot]');
        const prevBtn     = carousel.querySelector('[data-prev]');
        const nextBtn     = carousel.querySelector('[data-next]');
        const totalSlides = carousel.querySelectorAll('.editorial-blog__slide').length;

        const state = { current: 0, total: totalSlides };
        this.carousels[panelIndex] = { state, track, dots, carousel };

        if (totalSlides <= 1) {
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
        }

        if (prevBtn) prevBtn.addEventListener('click', () => this._goTo(panelIndex, state.current - 1));
        if (nextBtn) nextBtn.addEventListener('click', () => this._goTo(panelIndex, state.current + 1));

        dots.forEach((dot) => {
          dot.addEventListener('click', () => this._goTo(panelIndex, parseInt(dot.dataset.dot, 10)));
        });

        this._initDrag(wrapper, panelIndex);

        // Set pill fill duration based on autoplay speed
        const autoSpeed = parseInt(this.section.dataset.autoplaySpeed, 10) || 5500;
        const pillDur = (autoSpeed / 1000).toFixed(2) + 's';
        const dotsContainer = carousel.querySelector('[data-dots]');
        if (dotsContainer) dotsContainer.style.setProperty('--eb-pill-dur', pillDur);

        if (panel.classList.contains('is-active')) {
          this._startAutoplay(panelIndex);
          // Animate the first slide content on load
          const firstSlide = carousel.querySelector('.editorial-blog__slide');
          if (firstSlide) {
            setTimeout(() => this._animateSlideContent(firstSlide), 500);
          }
          // Restart first dot fill so it syncs with autoplay timing
          const firstDot = carousel.querySelector('[data-dot="0"]');
          if (firstDot) {
            firstDot.classList.remove('is-active');
            requestAnimationFrame(() => requestAnimationFrame(() => firstDot.classList.add('is-active')));
          }
        }
      });
    }

    _goTo(panelIndex, index) {
      const c = this.carousels[panelIndex];
      if (!c) return;
      const { state, track, dots, carousel } = c;
      state.current = ((index % state.total) + state.total) % state.total;
      track.style.transform = `translateX(-${state.current * 100}%)`;
      dots.forEach((dot, i) => {
        dot.classList.remove('is-active');
        if (i === state.current) {
          requestAnimationFrame(() => requestAnimationFrame(() => dot.classList.add('is-active')));
        }
      });

      // Animate content of the newly active slide
      const slides = carousel.querySelectorAll('.editorial-blog__slide');
      this._animateSlideContent(slides[state.current]);
    }

    _startAutoplay(panelIndex) {
      if (!this.section.dataset.autoplay || this.section.dataset.autoplay === 'false') return;
      const interval = parseInt(this.section.dataset.autoplaySpeed, 10) || 5500;
      this.autoplayTimers[panelIndex] = setInterval(() => {
        const c = this.carousels[panelIndex];
        if (c) this._goTo(panelIndex, c.state.current + 1);
      }, interval);
    }

    _stopAutoplay(panelIndex) {
      clearInterval(this.autoplayTimers[panelIndex]);
    }

    _restartAutoplay(panelIndex) {
      Object.keys(this.autoplayTimers).forEach((k) => this._stopAutoplay(k));
      this._startAutoplay(panelIndex);
    }

    _initDrag(wrapper, panelIndex) {
      let startX = 0, moved = false;

      wrapper.addEventListener('mousedown', (e) => {
        startX = e.clientX; moved = false;
        wrapper.classList.add('is-dragging');
        this._stopAutoplay(panelIndex);
      });
      wrapper.addEventListener('mousemove', (e) => {
        if (Math.abs(e.clientX - startX) > 5) moved = true;
      });
      wrapper.addEventListener('mouseup', (e) => {
        wrapper.classList.remove('is-dragging');
        if (!moved) { this._startAutoplay(panelIndex); return; }
        if (Math.abs(e.clientX - startX) > 50) {
          const c = this.carousels[panelIndex];
          this._goTo(panelIndex, c.state.current + (e.clientX < startX ? 1 : -1));
        }
        this._startAutoplay(panelIndex);
      });
      wrapper.addEventListener('mouseleave', () => wrapper.classList.remove('is-dragging'));

      wrapper.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX; moved = false;
        this._stopAutoplay(panelIndex);
      }, { passive: true });
      wrapper.addEventListener('touchmove', (e) => {
        if (Math.abs(e.touches[0].clientX - startX) > 5) moved = true;
      }, { passive: true });
      wrapper.addEventListener('touchend', (e) => {
        if (!moved) { this._startAutoplay(panelIndex); return; }
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          const c = this.carousels[panelIndex];
          this._goTo(panelIndex, c.state.current + (diff > 0 ? 1 : -1));
        }
        this._startAutoplay(panelIndex);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.editorial-blog').forEach((el) => {
      if (!el.editorialBlogInstance) {
        el.editorialBlogInstance = new EditorialBlog(el);
      }
    });
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.editorial-blog');
      if (section) section.editorialBlogInstance = new EditorialBlog(section);
    });
    document.addEventListener('shopify:section:unload', (e) => {
      const section = e.target.querySelector('.editorial-blog');
      if (section?.editorialBlogInstance) {
        Object.keys(section.editorialBlogInstance.autoplayTimers).forEach((k) => {
          clearInterval(section.editorialBlogInstance.autoplayTimers[k]);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zi-intentionally-chosen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zi-chosen-carousel')) {
    customElements.define('zi-chosen-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.track = this.querySelector('[data-zi-chosen-track]');
        this.pagination = this.querySelector('[data-zi-chosen-pagination]');
        if (!this.track || !this.pagination) return;

        this.slides = Array.from(this.track.querySelectorAll('[data-zi-chosen-slide]'));
        this.pages = Array.from(this.pagination.querySelectorAll('[data-zi-chosen-page]'));
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.mobileMedia = window.matchMedia('(max-width: 768px)');
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateCurrentPage();
          });
        };

        this.track.addEventListener('scroll', this.queueUpdate, { passive: true, signal });
        this.mobileMedia.addEventListener('change', this.queueUpdate, { signal });
        this.pagination.addEventListener('click', (event) => {
          const button = event.target.closest('[data-zi-chosen-page]');
          if (!button || !this.pagination.contains(button)) return;
          this.scrollToPage(Number(button.dataset.ziChosenPage));
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target) || !this.mobileMedia.matches) return;
          const index = this.slides.findIndex((slide) => slide.dataset.ziChosenSlide === event.detail.blockId);
          if (index >= 0) this.scrollToPage(index, true);
        }, { signal });

        this.resizeObserver = new ResizeObserver(this.queueUpdate);
        this.resizeObserver.observe(this.track);
        this.queueUpdate();
      }

      scrollToPage(index, immediate = false) {
        const slide = this.slides[Math.min(index, this.pages.length - 1)];
        if (!slide || !this.mobileMedia.matches) return;
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const delta = rtl ? slideRect.right - trackRect.right : slideRect.left - trackRect.left;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: delta, behavior: immediate || reducedMotion ? 'auto' : 'smooth' });
        this.queueUpdate();
      }

      updateCurrentPage() {
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;
        this.pagination.hidden = !this.mobileMedia.matches || !hasOverflow;
        if (this.pagination.hidden) return;

        const trackRect = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let currentIndex = 0;
        let closestDistance = Infinity;
        this.slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rtl ? rect.right - trackRect.right : rect.left - trackRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            currentIndex = index;
          }
        });
        const remainingScroll = this.track.scrollWidth - this.track.clientWidth - Math.abs(this.track.scrollLeft);
        if (remainingScroll <= 1) currentIndex = this.pages.length - 1;
        currentIndex = Math.min(currentIndex, this.pages.length - 1);
        this.pages.forEach((page, index) => {
          if (index === currentIndex) page.setAttribute('aria-current', 'true');
          else page.removeAttribute('aria-current');
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zi-triple-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zi-triple-editorial')) {
    customElements.define('zi-triple-editorial', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        this.track = this.querySelector('.zi-triple-editorial__inner');
        this.pagination = this.querySelector('.zi-triple-editorial__pagination');
        this.cards = Array.from(this.querySelectorAll('.zi-triple-editorial__card'));
        this.pages = Array.from(this.querySelectorAll('[data-carousel-page]'));
        if (!this.track) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        const scheduleUpdate = () => {
          cancelAnimationFrame(this.updateFrame);
          this.updateFrame = requestAnimationFrame(() => this.updatePagination());
        };

        this.track.addEventListener('scroll', scheduleUpdate, {passive: true, signal});
        this.pagination?.addEventListener('click', event => {
          const page = event.target.closest('[data-carousel-page]');
          if (page && this.pagination.contains(page)) {
            this.goTo(Number(page.dataset.carouselPage));
          }
        }, {signal});

        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.ziBlockId === event.detail?.blockId);
          if (index !== -1) this.goTo(index);
        }, {signal});

        this.observer = new ResizeObserver(scheduleUpdate);
        this.observer.observe(this.track);
        if (this.pagination) this.pagination.hidden = this.cards.length < 2;
        this.updatePagination();
      }

      goTo(index) {
        if (!matchMedia('(max-width: 749px)').matches || !this.cards[index]) return;
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const left = this.track.scrollLeft + this.cards[index].getBoundingClientRect().left
          - this.track.getBoundingClientRect().left - padding;
        this.track.scrollTo({
          left,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      updatePagination() {
        if (!this.cards.length) return;
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const start = this.track.getBoundingClientRect().left + padding;
        let activeIndex = 0;
        let nearest = Infinity;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - start);
          if (distance < nearest) {
            nearest = distance;
            activeIndex = index;
          }
        });

        this.pages.forEach((page, index) => {
          page.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.updateFrame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
